<template>
    <div class="turnstile-wrapper">
        <div ref="widgetContainer"></div>
    </div>
</template>

<script setup>
/* global defineProps, defineEmits, defineExpose */
/* eslint-disable no-undef */
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'

const props = defineProps({
    // Cloudflare 控制台获取的 Sitekey（测试 Key 可用: 1x00000000000000000000AA）
    sitekey: {
        type: String,
        default: '1x00000000000000000000AA'
    },
    theme: {
        type: String,
        default: 'auto' // 'light' | 'dark' | 'auto'
    }
})

const emit = defineEmits(['verify', 'expire', 'error'])

const widgetContainer = ref(null)
let widgetId = null
let pollTimer = null

// 初始化 Turnstile 挂载
const renderTurnstile = () => {
    if (window.turnstile && widgetContainer.value) {
        // 如果已经渲染过，先移除
        if (widgetId !== null) {
            try {
                window.turnstile.remove(widgetId)
            } catch (e) {
                // ignore
            }
            widgetId = null
        }
        widgetId = window.turnstile.render(widgetContainer.value, {
            sitekey: props.sitekey,
            theme: props.theme,
            callback: (token) => {
                emit('verify', token)
            },
            'expired-callback': () => {
                emit('expire')
            },
            'error-callback': () => {
                emit('error')
            }
        })
    }
}

// 供父组件在提交失败或需要重置时调用
const reset = () => {
    if (window.turnstile && widgetId !== null) {
        window.turnstile.reset(widgetId)
    }
}

defineExpose({ reset })

watch(() => props.sitekey, () => {
    renderTurnstile()
})

onMounted(() => {
    if (window.turnstile) {
        renderTurnstile()
    } else {
        let attempts = 0
        pollTimer = setInterval(() => {
            attempts++
            if (window.turnstile) {
                clearInterval(pollTimer)
                pollTimer = null
                renderTurnstile()
            } else if (attempts > 50) { // 5秒超时
                clearInterval(pollTimer)
                pollTimer = null
                console.warn('Turnstile script failed to load or timed out.')
            }
        }, 100)
    }
})

onBeforeUnmount(() => {
    if (pollTimer) {
        clearInterval(pollTimer)
        pollTimer = null
    }
    if (window.turnstile && widgetId !== null) {
        try {
            window.turnstile.remove(widgetId)
        } catch (e) {
            // ignore
        }
    }
})
</script>

<style scoped>
.turnstile-wrapper {
    display: flex;
    justify-content: center;
    margin: 15px 0;
}
</style>